import { allTrackers } from "app/services/track/track";
import { translate } from "app/filters/i18nFilter";

import type { IFoldersFilters } from "../../../types";

interface IRadioFilters {
    setFilters: (updater: (prev: IFoldersFilters) => IFoldersFilters) => void;
}

interface IUseTableActionsProps {
    downloadExcelPermitted: boolean;
    excelLink: string;
    onFilterChange: (filters: Partial<IFoldersFilters>) => void;
    radioFilters: IRadioFilters;
}

export const useTableActions = ({
    downloadExcelPermitted,
    excelLink,
    onFilterChange,
    radioFilters,
}: IUseTableActionsProps) => {
    const excelDownloadUrl = downloadExcelPermitted ? excelLink : "";

    const settingsLocale = {
        addToDashboardTooltip: translate("common.addtodashboard.button.tooltip"),
    };

    const excelExportConfig = {
        excelDownloadUrl,
        onExcelDownloaded: () => {
            allTrackers.dispatchTrackEvent("Download", "click", "Table/Excel");
        },
    };

    const onSearchChange = (searchValue: string) => {
        const filterValue = `Folder;contains;"${searchValue?.trim()}"`;
        onFilterChange({ filter: filterValue });
        radioFilters.setFilters((prev: IFoldersFilters) => ({ ...prev, filter: filterValue }));
    };

    return {
        settingsLocale,
        excelExportConfig,
        onSearchChange,
    };
};
